import { render, staticRenderFns } from "./crmClientProjects.vue?vue&type=template&id=781a5284"
import script from "./crmClientProjects.vue?vue&type=script&lang=js"
export * from "./crmClientProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports